import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { actions } from './actions';
import { mutations } from './mutations';
import { ErrorToasterState, state } from './state';

const module: Module<ErrorToasterState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
};

export default module;
export type {ErrorToasterState};